import Stat from '@/api/admin_stats.api.js'

/*eslint-disable */
export const getStat = ({ commit }, data) => {
  return Stat.getOrganizationStat(data)
    .then(response => {
      commit("SET_STAT", response.data)
      return response.data;
    })
}

export const getMonthlyStats = ({ commit }, data) => {
  return Stat.getOrganizationStat(data)
    .then(response => {
      commit("SET_MONTHLY_STATS", response.data)
      return response.data;
    })
}

export const getTemplateStats = ({ commit }, data) => {
  return Stat.getTemplateStats(data)
    .then(response => {
      commit("SET_TEMPLATE_STATS", response.data)
      return response.data;
    })
}
/*eslint-enable */